import { ActionIcon, CopyButton, Group, MantineSize, Text, Tooltip } from "@mantine/core";
import { IconCheck, IconCopy } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

interface PhoneCopyProps {
  phone: string;
  fz?: number;
  c?: string;
  iconSize?: number;
  size?: MantineSize;
}

const PhoneCopy = ({ phone, fz = 13, c, iconSize = 14, size = "sm" }: PhoneCopyProps) => {
  const { t } = useTranslation();

  return (
    <Group gap={4} wrap="nowrap">
      <Text fz={fz} c={c}>
        {phone}
      </Text>
      <CopyButton value={phone} timeout={1200}>
        {({ copied, copy }) => (
          <Tooltip
            label={copied ? t("dashboard.call.actions.copied") : t("dashboard.call.actions.copy")}
            withArrow
          >
            <ActionIcon
              aria-label={t("dashboard.call.actions.copy")}
              variant="subtle"
              color={copied ? "green" : "gray"}
              size={size}
              radius="xl"
              onClick={(e) => {
                e.stopPropagation();
                copy();
              }}
            >
              {copied ? <IconCheck size={iconSize} /> : <IconCopy size={iconSize} />}
            </ActionIcon>
          </Tooltip>
        )}
      </CopyButton>
    </Group>
  );
};

export default PhoneCopy;
